// src/pages/dashboard/shared/Reviews.jsx
import { useState, useEffect } from 'react';
import api from '../../../lib/api';
import { Star } from 'lucide-react';
import LoadingSpinner from '../../../components/common/LoadingSpinner';

export default function Reviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/reviews/my-reviews')
      .then(res => setReviews(res.data.data || []))
      .finally(() => setLoading(false));
  }, []);

  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <Star
        key={i}
        size={28}
        className={i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}
      />
    ));
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="max-w-5xl mx-auto space-y-12 py-10">
      <div className="text-center">
        <h1 className="text-5xl font-bold">Your Reviews</h1>
        <p className="text-xl text-gray-600 mt-4">
          {reviews.length} review{reviews.length !== 1 ? 's' : ''} from employers
        </p>
      </div>

      {reviews.length === 0 ? (
        <div className="text-center py-20 bg-gray-50 rounded-3xl">
          <Star size={80} className="mx-auto text-gray-300 mb-6" />
          <h3 className="text-3xl font-bold text-gray-600">No reviews yet</h3>
          <p className="text-xl text-gray-500 mt-4">Complete a contract to receive your first review!</p>
        </div>
      ) : (
        <div className="grid gap-8">
          {reviews.map((review) => (
            <div key={review.id} className="bg-white rounded-3xl shadow-xl p-10 border">
              <div className="flex items-start justify-between mb-6">
                <div className="flex items-center gap-5">
                  <div className="w-16 h-16 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center text-white text-2xl font-bold">
                    {review.customer_name[0]}
                  </div>
                  <div>
                    <h4 className="text-2xl font-bold">{review.customer_name}</h4>
                    <p className="text-gray-600">{new Date(review.created_at).toLocaleDateString('en-GB')}</p>
                  </div>
                </div>
                <div className="flex">{renderStars(review.rating)}</div>
              </div>
              <p className="text-xl text-gray-700 leading-relaxed italic">"{review.comment}"</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}